import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { toast, ToastContainer } from 'react-toastify';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import { ResponseError } from '../../../common/spdCore/autogenerated/spdApiClient';

export const ExternalReferralPreviewLink = (props: { examId: string }) => {
  const spd = useSpdCore();

  const handleClick = () => {
    spd.pdfPrinter
      .loadAndPrintExternalReferral(props.examId)
      .catch(async response => {
        const error = await responseErrors(response as ResponseError);

        toast.error(
          `Wystąpił problem z wydrukiem skierowania zewnętrznego. ${error}`,
        );
      });
  };

  return (
    <>
      <ToastContainer />
      <OverlayTrigger
        overlay={
          <Tooltip style={{ position: 'fixed' }}>
            Wydruk skierowania zewnętrznego
          </Tooltip>
        }
      >
        <Button
          onClick={e => {
            e.stopPropagation();
            handleClick();
          }}
          variant="btn-info"
        >
          <Icon.PrinterFill />
        </Button>
      </OverlayTrigger>
    </>
  );
};
